const SET_DATA = 'SET_DATA';
const REMOVE_DATA = 'REMOVE_DATA';
const REMOVE_AUTH_FLAG = 'REMOVE_AUTH_FLAG';
const GET_ROOT_LINKS = 'GET_ROOT_LINKS';
const CLEAR = 'CLEAR';
const GET_ROOT_LINKS_AUTH = 'GET_ROOT_LINKS_AUTH';
const SET_DATA_AUTH = 'SET_DATA_AUTH';
const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';

export default {
	SET_DATA,
	REMOVE_DATA,
	GET_ROOT_LINKS,
	CLEAR,
	GET_ROOT_LINKS_AUTH,
	REMOVE_AUTH_FLAG,
	SET_DATA_AUTH,
	SET_WINDOW_SIZE,
};
